import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["disabled", "href", "className", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import Link from 'next/link';
import React, { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ListsDropdown = _ref => {
  let {
    className = '',
    placement = 'right',
    children
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.dropdown, styles[`dropdown--${placement}`], className),
    children: children
  });
};

export default ListsDropdown; //
// Trigger Element
// NOTE: Delay closing so links/events can complete bubbling

export const Button = _ref2 => {
  let {
    disabled = false,
    open: controlledOpen = false,
    onOpenStateChange,
    className = '',
    onClick,
    children
  } = _ref2;
  const ref = useRef(null);
  const timeoutRef = useRef(null);
  const {
    0: isActive,
    1: setActive
  } = useState(false);
  useClickAway(ref, () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => handleOpenStateChange(false), 200);
  });

  const handleOpenStateChange = open => {
    setActive(open);
    typeof onOpenStateChange === 'function' && onOpenStateChange(open);
  };

  const isDropdownActive = controlledOpen || isActive;
  return /*#__PURE__*/_jsx("button", {
    type: "button" // @ts-ignore
    ,
    ref: ref,
    disabled: disabled,
    onClick: e => {
      handleOpenStateChange(true);
      typeof onClick === 'function' && onClick(e);
    },
    className: clsx(styles['-trigger'], isDropdownActive ? styles['-active'] : '', className),
    children: children
  });
}; //
// Child Elements
//

export const Item = _ref3 => {
  let {
    className = '',
    children
  } = _ref3;
  return /*#__PURE__*/_jsx("li", {
    className: clsx(styles.dropdown__item, className),
    children: children
  });
};
export const Action = _ref4 => {
  let {
    disabled = false,
    href = '',
    className = '',
    children
  } = _ref4,
      args = _objectWithoutProperties(_ref4, _excluded);

  if (href) {
    return /*#__PURE__*/_jsx(Link, {
      legacyBehavior: true,
      href: href,
      children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
        className: clsx(styles.dropdown__action, {
          [styles['dropdown__action--disabled']]: disabled
        }, className)
      }, args), {}, {
        children: children
      }))
    });
  }

  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: clsx(styles.dropdown__action, {
      [styles['dropdown__action--disabled']]: disabled
    }, className)
  }, args), {}, {
    children: children
  }));
};